import { formatInitial } from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";

export default function HandleDocumentFormat(state = formatInitial, action) {
  const { type, payload } = action;
  switch (type) {
    case types.SET_DOCUMENT_FORMAT:
      return { documentsType: payload };
    default:
      return state;
  }
}
